import {createContext} from 'react';

import type {RegistrationService} from '../services/Registration.service';

export const RegistrationContext = createContext<
    RegistrationService | undefined
>(undefined);
